export interface SessionUser {
  id: string;
  role: string;
  organizationId: string | null;
  email: string | null;
}

export interface Session {
  accessToken: string;
  refreshToken: string;
  expiresAt: number;
  user: SessionUser;
}

export const OPERATOR_ROLE = 'operator' as const;
